import React from 'react';
import i18n, { formatNumber } from '@/utils/i18n';
import { CustomModal } from '../../../../components/CustomModal';
import OrderFulfillmentAddContainerTypes, {
  ContainerType as SelectorContainerType,
} from './OrderFulfillmentAddContainerTypes';
import { Button, Input, Table } from 'reactstrap';
import ContainerTypeDisplay from '../../../../components/ContainerType/ContainerTypeDisplay';
import { FaEdit } from 'react-icons/fa';
import {
  ContainerTypeAmount,
  OrderFulfillmentType,
} from '../../../../graphql/generatedTypes';

type CountUncountedModalProps = {
  isOpen: boolean;
  setIsOpen: (v: boolean) => void;
  orderFulfillmentType: OrderFulfillmentType;
  manualAmounts: ContainerTypeAmount[];
  setManualAmounts: (newAmounts: ContainerTypeAmount[]) => void;
  allContainerTypes: SelectorContainerType[];
  containerTypesForSelector: SelectorContainerType[];
  acceptButtonDisabled: boolean;
  onAccept: () => Promise<void>;
};

const CountUncountedModal: React.FC<CountUncountedModalProps> = ({
  isOpen,
  setIsOpen,
  orderFulfillmentType,
  manualAmounts,
  setManualAmounts,
  allContainerTypes,
  containerTypesForSelector,
  acceptButtonDisabled,
  onAccept,
}) => {
  const isReturn = orderFulfillmentType === OrderFulfillmentType.Return;

  return (
    <CustomModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      header={i18n.t('OrderFulfillment:countUncountedHeader')}
      body={
        <div>
          <OrderFulfillmentAddContainerTypes
            isDisabled={acceptButtonDisabled}
            containerTypes={allContainerTypes}
            orderFulfillmentType={orderFulfillmentType}
            manualAmounts={manualAmounts}
            setManualAmounts={setManualAmounts}
            hideAmountCleanColumn={isReturn}
          />

          <Table striped hover bordered>
            <thead>
              <tr>
                <th>{i18n.t('CreateOrderFulfillment:containerType')}</th>
                {isReturn ? (
                  <th>{i18n.t('Common:amountDirty')}</th>
                ) : (
                  <th>{i18n.t('Common:amountClean')}</th>
                )}
                <th>{i18n.t('Common:sum')}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {manualAmounts.map((ma, idx) => (
                <tr key={`${ma.container_type_id}-${idx}`}>
                  <td className="align-middle">
                    <ContainerTypeDisplay
                      containerType={
                        allContainerTypes.find(
                          (ct) => ct.id === ma.container_type_id,
                        ) ||
                        containerTypesForSelector.find(
                          (ct) => ct.id === ma.container_type_id,
                        )
                      }
                    />
                  </td>
                  {isReturn ? (
                    <td className="align-middle">
                      <Input
                        type="number"
                        min={0}
                        value={ma.amount || 0}
                        onChange={(e) => {
                          const newArr = [...manualAmounts];
                          newArr[idx] = {
                            ...newArr[idx],
                            amount: Number(e.target.value || '0') as any,
                          };
                          setManualAmounts(newArr);
                        }}
                        style={{ width: '100px' }}
                      />
                    </td>
                  ) : (
                    <td className="align-middle">
                      <Input
                        type="number"
                        min={0}
                        value={ma.amount || 0}
                        onChange={(e) => {
                          const newArr = [...manualAmounts];
                          newArr[idx] = {
                            ...newArr[idx],
                            amount: Number(e.target.value || '0') as any,
                          };
                          setManualAmounts(newArr);
                        }}
                        style={{ width: '100px' }}
                      />
                    </td>
                  )}
                  <td className="numbers-formatted align-middle">
                    {formatNumber(
                      Number(ma.amount || 0) + Number(ma.amount_sealed || 0),
                    )}
                  </td>
                  <td className="align-middle">
                    <Button
                      color="danger"
                      onClick={() => {
                        setManualAmounts(
                          manualAmounts.filter((_, i) => i !== idx),
                        );
                      }}
                    >
                      {i18n.t('Common:remove')}
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      }
      acceptButtonText={i18n.t('Common:count')}
      acceptButtonIcon={<FaEdit />}
      acceptButtonDisabled={acceptButtonDisabled}
      acceptButtonAction={onAccept}
      size="xl"
    />
  );
};

export default CountUncountedModal;
